<template>
  <div id="app">
    <template v-if="currentPc == true">
      <pcpage />
    </template>
    <template v-else-if="currentMoblie == true">
      <mobliepage />
    </template>
  </div>
</template>
<style>
@import "./assets/style/normalize.css";
</style>
<script>
import { mapState } from "vuex";
import { setTimeout } from "timers";
import mobliepage from "@/components/moblieDetail";
import pcpage from "@/components/pcDetail";
export default {
  name: "detail",
  components: {
    mobliepage,
    pcpage,
  },
  data() {
    return {
      currentPc: false,
      currentMoblie: false,
      moblieDeviceType: "",
      type: window.GLOBAL.browser.versions,
    };
  },
  beforeCreate() {
    window.GLOBAL = {
      browser: {
        versions: (function () {
          var e = navigator.userAgent;
          return {
            qq: "qq" === e.match(/\sQQ/i),
            uc: -1 < e.indexOf("UCBrowser"),
            ios: !!e.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            iPad: -1 < e.indexOf("iPad"),
            gecko: -1 < e.indexOf("Gecko") && e.indexOf("KHTML") < 0,
            presto: -1 < e.indexOf("Presto"),
            webkit: -1 < e.indexOf("AppleWebKit"),
            mobile: !!e.match(/AppleWebKit.*Mobile.*/),
            iPhone: -1 < e.indexOf("iPhone"),
            webApp: e.indexOf("Safari") < 0,
            safari:
              !!e.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
              -1 < e.indexOf("Safari"),
            weChat: -1 < e.indexOf("MicroMessenger"),
            aliPay: !!e.match(/Alipay/i),
            trident: -1 < e.indexOf("Trident"),
            android: -1 < e.indexOf("Android") || -1 < e.indexOf("Linux"),
            qqBrowser: -1 < e.indexOf("MQQBrowser"),
          };
        })(),
        language: (
          navigator.browserLanguage || navigator.language
        ).toLowerCase(),
      },
    };
  },
  mounted() {
    var device = "moblie";
    var BrowserVersion = window.GLOBAL.browser.versions;
    var nua = navigator.userAgent;
    var is_android =
      nua.indexOf("Mozilla/5.0") > -1 &&
      nua.indexOf("Android ") > -1 &&
      nua.indexOf("AppleWebKit") > -1 &&
      !(nua.indexOf("Chrome") > -1);
    if (BrowserVersion.android == true || is_android == true) {
      this.currentMoblie = true;
      if (BrowserVersion.weChat == true) {
        this.moblieDeviceType = "wx";
        this.$store.commit("sendDeviceType", "wx");
      } else if (
        /MQQBrowser/i.test(navigator.userAgent) &&
        /\sQQ/i.test(navigator.userAgent.split("MQQBrowser"))
      ) {
        this.moblieDeviceType = "qq";
        this.$store.commit("sendDeviceType", "qq");
      } else {
        this.moblieDeviceType = "android";
        this.$store.commit("sendDeviceType", "android");
      }
    } else if (
      BrowserVersion.ios == true ||
      BrowserVersion.iPhone == true ||
      BrowserVersion.iPad == true
    ) {
      this.currentMoblie = true;

      if (BrowserVersion.weChat == true) {
        this.moblieDeviceType = "wx";
        this.$store.commit("sendDeviceType", "wx");
      } else if (/\sQQ/i.test(navigator.userAgent)) {
        this.moblieDeviceType = "qq";
        this.$store.commit("sendDeviceType", "qq");
      } else {
        this.moblieDeviceType = "ios";
        this.$store.commit("sendDeviceType", "ios");
      }
    } else {
      this.currentPc = true;
    }
    // console.log('currentPc',this.currentPc);
    // console.log('currentMoblie',this.currentMoblie);
  },
  computed: {
    returnSlideW: function () {
      return this.slideW;
    },
  },
  methods: {},
};
</script>

